import styled from 'styled-components/macro';

import Button from 'components/Button/Button';

export const getPopupContentStyle = (isMobile: boolean) => ({
  width: isMobile ? '100%' : '430px',
  height: isMobile ? '100%' : 'auto',
  padding: '1.5rem 0 2.25rem',
  maxHeight: window.matchMedia('(orientation: landscape)').matches ? '95vh' : '100vh',
  overflow: 'auto',
});

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 38px;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;
